import { render, staticRenderFns } from "./DeleteApplyDetail.vue?vue&type=template&id=2a711e7c&scoped=true&"
import script from "./DeleteApplyDetail.vue?vue&type=script&lang=js&"
export * from "./DeleteApplyDetail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.css?vue&type=style&index=0&id=2a711e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a711e7c",
  null
  
)

export default component.exports